import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import { inject } from "@angular/core";
import { ErrorFacade } from "../store/facade/error.facade";

export function httpErrorInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const errorFacade = inject(ErrorFacade);

    return next(request).pipe(
        catchError((error) => {
            errorFacade.onShowError(error);
            throw error;
        }),
    );
}
